/**
 * Couleurs AA des états écrits en texte, par thème : miroir des jetons
 * `--color-*-text` de `index.css`, pour les endroits qui peignent hors du thème
 * courant (l'aperçu clair/sombre du branding). `theme-contrast.spec.ts` vérifie
 * que les deux sources restent identiques.
 */
export const STATUS_TEXT = {
  light: { success: '#166534', warning: '#854d0e', error: '#b91c1c', info: '#075985' },
  dark: { success: '#4ade80', warning: '#facc15', error: '#f87171', info: '#7dd3fc' },
} as const
